export default __webpack_public_path__ + "static/media/hello2u.670e06db.jpg";